(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-media-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    const load = (v) => {
      const s = v.querySelector('source[data-src]');
      if (s) {
        s.src = s.dataset.src;
        s.removeAttribute('data-src');
        v.load();
      }
    };
    const play = (v) => {
      load(v);
      const p = v.play();
      if (p) p.then(() => v.classList.add('is-playing')).catch(() => {});
    };
    const stop = (v) => {
      v.pause();
      v.classList.remove('is-playing');
    };
    const canHover = window.matchMedia('(hover: hover)').matches;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const io =
      !canHover && !reduced && 'IntersectionObserver' in window
        ? new IntersectionObserver(
            (entries) => entries.forEach((e) => (e.intersectionRatio >= 0.6 ? play(e.target) : stop(e.target))),
            { threshold: [0, 0.6] }
          )
        : null;
    const init = () => {
      document.querySelectorAll('video.product-card-video-preview:not([data-init])').forEach((v) => {
        v.dataset.init = '1';
        if (canHover) {
          const card = v.closest('product-card') || v.parentElement;
          card.addEventListener('mouseenter', () => play(v));
          card.addEventListener('mouseleave', () => stop(v));
        } else if (io) {
          io.observe(v);
        }
      });
    };
    init();
    new MutationObserver(init).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
